// client/src/components/reports/useReportRun.js
//
// Poll a report run (export or heavy preview) until it finishes. The worker
// polls its queue every ~15 s, so polling starts at 2 s and backs off to 5 s;
// it gives up after 10 minutes.

import { useEffect, useRef, useState } from 'react';
import { getRun } from '../../services/reportsApi';

const FINAL = new Set(['done', 'failed', 'expired']);

export default function useReportRun(runId) {
  const [run, setRun] = useState(null);
  const [error, setError] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    setRun(null);
    setError(null);
    if (!runId) return undefined;
    let cancelled = false;
    const started = Date.now();
    let delay = 2000;
    const tick = async () => {
      try {
        const res = await getRun(runId);
        if (cancelled) return;
        setRun(res.run);
        if (FINAL.has(res.run.status)) return;
      } catch (err) {
        if (cancelled) return;
        setError(err);
        return;
      }
      if (Date.now() - started > 10 * 60 * 1000) return;
      delay = Math.min(5000, Math.round(delay * 1.3));
      timer.current = setTimeout(tick, delay);
    };
    tick();
    return () => {
      cancelled = true;
      clearTimeout(timer.current);
    };
  }, [runId]);

  return { run, error, finished: !!run && FINAL.has(run.status) };
}
